import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { BiSolidError } from "react-icons/bi";
// import { FiEdit } from "react-icons/fi";
import { IoCloseSharp } from "react-icons/io5";
// import { RiDeleteBin6Fill } from "react-icons/ri";
import "react-loading-skeleton/dist/skeleton.css";
// import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import AdminPagination from "../../../component/pagination/AdminPagination";
import SkeletonLoading from "../../../component/SkeletonLoading";
import {
  useDeleteMultiUserMutation,
  useGetAllUsersQuery,
} from "../../../store/api/userSlice";
import { getErrorMessage } from "../../../utils";
import "./myschools.scss";
import { useTranslation } from "react-i18next";
import i18n from "../../../store/api/i18n";

const SchoolPage = () => {
  const { t } = useTranslation();
  const [action, setAction] = useState("");
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);

  const [users, setusers] = useState([]);
  const [search, setSearch] = useState("");
  // state for single and multi user store id
  const [selectedUser, setSelectedUser] = useState([]);

  const [pagination, setPagination] = useState({ limit: 10, page: 1 });
  const [filters, setFilters] = useState({ email: "", role: "school" });

  const { data, isSuccess, isLoading, isError, error, isFetching, refetch } =
    useGetAllUsersQuery({
      page: pagination.page,
      limit: pagination.limit,
      ...filters,
    });

  const [deleteMultiUser, { isLoading: isMultiDeleteLoading }] =
    useDeleteMultiUserMutation();

  if (isError) {
    toast.dismiss();
    toast.error(getErrorMessage(error));
  }

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit) => {
    setPagination((prev) => ({
      ...prev,
      limit,
      page: 1,
    }));
  };

  useEffect(() => {
    if (isSuccess && data?.data) {
      setusers(data.data.users);
      setPagination((prev) => {
        const { total, page, limit, pages } = data.data.pagination;
        const safePage = Math.min(page, Math.max(1, pages || 1));
        return {
          ...prev,
          total,
          limit,
          totalPages: pages,
          page: safePage,
        };
      });
    }
  }, [data, isSuccess]);

  useEffect(() => {
    if (!search.trim()) {
      setFilters((prev) => ({ ...prev, email: "" }));
    }
  }, [search]);

  // for check user
  const handleCheckUser = (id) => {
    setSelectedUser(
      (prev) =>
        prev.includes(id)
          ? prev.filter((userId) => userId !== id) // Remove if already selected
          : [...prev, id], // Add if not selected
    );
  };

  // handle check all user
  const handleCheckAll = () => {
    const allIds = users.map((curElem) => curElem.id);
    setSelectedUser((prev) => (prev.length === users.length ? [] : allIds));
  };

  const handleUserAction = async () => {
    toast.dismiss();
    if (action !== "deleteMulti") return;

    try {
      const response = await deleteMultiUser({
        userIds: selectedUser,
      }).unwrap();

      if (response.statusCode === 201 || response.statusCode === 200) {
        toast.success(response.message || "Users deleted successfully");
        setShowConfirmDelete(false);
        setSelectedUser([]);
        setAction("");
        refetch();
      }
    } catch (err) {
      const mesg = err?.data?.message || "Something went wrong";
      toast.error(mesg);
    }
  };

  const handleSearch = () => {
    const trimmedEmail = search.trim();
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail);
    if (isValidEmail) {
      setFilters((prev) => ({ ...prev, email: trimmedEmail }));
    } else {
      toast.error(t("invalidEmail"));
    }
  };

  const handleClose = () => setShowConfirmDelete(false);

  const onGoClick = () => {
    if (!action) {
      toast.error(t("selectFirst"));
      return;
    }

    if (action === "deleteMulti") {
      if (!selectedUser?.length) {
        toast.error(t("selectToDelete"));
        return;
      }
      setShowConfirmDelete(true);
    }
  };

  // Language Change Handler
  useEffect(() => {
    const h = () => {
      refetch?.();
    };
    i18n.on("languageChanged", h);
    return () => i18n.off("languageChanged", h);
  }, [refetch]);

  return (
    <>
      <div className="adminVendorSchools">
        <div className="d-flex mb-2 justify-content-between flex-wrap align-items-center">
          <div className="total">
            {t("total")} {t("schools")}: {pagination?.total}
          </div>
          {/* <div className="mb-2 filterBox justify-content-start align-items-start"> */}
          <div className="d-flex">
            <input
              type="email"
              className="form-control custom-field-one me-2"
              placeholder={`${t("search")} ${t("by")} ${t("email")}`}
              value={search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              onChange={(e) => setSearch(e.target.value)}
            />

            <button className="btn btn-primary me-2" onClick={handleSearch}>
              {t("search")}
            </button>
          </div>
          {/* <div className="d-flex align-items-center">
            <span className="selected-info me-2">
              {selectedUser.length} of {users.length} {t("selected")}
            </span>
            <select
              className="formSelect custom-field-two me-2"
              value={action}
              onChange={(e) => setAction(e.target.value)}
            >
              <option value="">
                {" "}
                {t("select")} {t("bulk")} {t("actions")}
              </option>
              <option value="deleteMulti">
                {t("delete")} {t("selected")} {t("users")}
              </option>
            </select>
            <button className="btn btn-primary" onClick={onGoClick}>
              {t("go")}
            </button>
          </div> */}
          {/* </div> */}
        </div>

        <div className="table m-0">
          <table>
            <thead>
              <tr>
                <th>
                  {t("SR")}.{t("no")}.
                </th>
                <th>
                  {t("full")} {t("name")}
                </th>
                <th>
                  {t("company")} {t("name")}
                </th>
                <th>{t("email")}</th>
                <th>
                  {t("contact")} {t("number")}
                </th>
                <th
                  className="text-nowrap"
                  style={{ minWidth: "400px", width: "auto" }}
                >
                  {t("address")}
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading || isFetching ? (
                <SkeletonLoading length={6} />
              ) : users.length > 0 ? (
                users.map((curElem, i) => (
                  <tr key={curElem.id}>
                    <td>
                      <td>
                        {(pagination.page - 1) * pagination.limit + i + 1}
                      </td>
                    </td>
                    <td className="text-nowrap">
                      {curElem.full_name ? curElem.full_name : "N/A"}
                    </td>
                    <td className="text-nowrap">
                      {curElem.company_name ? curElem.company_name : "N/A"}
                    </td>
                    <td className="text-nowrap">
                      {curElem.email ? curElem.email : "N/A"}
                    </td>
                    <td className="text-nowrap">
                      {curElem.phone ? curElem.phone : "N/A"}
                    </td>
                    <td style={{ minWidth: "400px" }}>
                      {curElem.street ? curElem.street : "N/A"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" align="center">
                    {t("no")} {t("school")} {t("found")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      <AdminPagination
        totalPages={pagination.totalPages}
        currentPage={pagination.page}
        limit={pagination.limit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
      />

      <Modal show={showConfirmDelete}>
        {" "}
        <Button className="closePopup" onClick={handleClose}>
          <IoCloseSharp />
        </Button>
        <div className="popupBox p-3 p-md-5">
          <div>
            <div className="text-center mb-3 errorIcon">
              <BiSolidError />
            </div>
            <div className="text-center mb-4 deleteHd">
              {t("confirmDelete")}
            </div>
            <div className="text-center">
              <Button className="smallBtn cancel me-3" onClick={handleClose}>
                {t("btns.cancel")}
              </Button>
              <Button
                className="smallBtn auto"
                onClick={handleUserAction}
                disabled={isMultiDeleteLoading}
              >
                {isMultiDeleteLoading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only p-0"></span>
                  </div>
                ) : (
                  t("btns.delete")
                )}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SchoolPage;
